import styled, { css } from 'styled-components';

import { Box, StyledLink } from '@core/component';
import { LinkColorType } from '@core/type';
import { getLinkColorProps } from '@core/util';

export const ProductPriceWrapper = styled(Box)<{ isUnderlinedHover: boolean }>(({
  theme: {
    palette,
    structure: {
      link: { underlineSecondPath },
    },
  },
  color: colorProps,
  transition,
  isUnderlinedHover,
}) => {
  const {
    color,
    hover: { color: hoverColor },
  } = getLinkColorProps({ color: colorProps as LinkColorType, palette });

  return css`
    display: flex;
    gap: 8px;
    cursor: pointer;

    ${StyledLink} {
      color: ${color};
      transition: ${transition};
    }

    &:hover ${StyledLink} {
      color: ${hoverColor};
      ${isUnderlinedHover && underlineSecondPath};
    }
  `;
});
